import { combineReducers, Reducer } from 'redux';
import { all } from 'typed-redux-saga';

import * as auth from './auth';
import * as dictionary from './dictionary';
import * as global from './global';
import * as identification from './identification';
import * as invoice from './invoice';
import { RootState } from './types';
import * as wallets from './wallets';
import * as withdrawal from './withdrawal';

export function* rootSaga(): Generator {
  yield* all([
    global.sagas(),
    auth.sagas(),
    dictionary.sagas(),
    identification.sagas(),
    invoice.sagas(),
    wallets.sagas(),
    withdrawal.sagas(),
  ]);
}

export const rootReducer = (): Reducer<RootState> =>
  combineReducers<RootState>({
    global: global.reducers,
    auth: auth.reducers,
    dictionary: dictionary.reducers,
    identification: identification.reducers,
    invoice: invoice.reducers,
    wallets: wallets.reducers,
    withdrawal: withdrawal.reducers,
  });

export default {
  rootReducer,
  rootSaga,
  global,
  auth,
  dictionary,
  identification,
  invoice,
  wallets,
  withdrawal,
};
